import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col, Card, Alert } from "react-bootstrap";
import SimpleHeader from "components/Headers/SimpleHeader";
import { serverHost } from "variables/serverdata";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { Input } from "reactstrap";

const conditionTypeOptions = [
  "",
  "context",
  "username",
  "rdnis",
  "destination_number",
  "public",
  "caller_id_name",
  "caller_id_number",
  "ani",
  "ani2",
  "uuid",
  "source",
  "channel_name",
  "network_addr"
];

const dialplans = [
  { value: "transfer:*98 XML 10.0.190.48", label: "Check Voicemail" },
  { value: "transfer:*411 XML 10.0.190.48", label: "Company Directory" },
  { value: "hangup:", label: "Hangup" },
  { value: "transfer:*732 XML 10.0.190.48", label: "Record" },
];

const DialplanInboundAdd = () => {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const [advanced, setAdvanced] = useState(false)
  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const domain_uuid = currentSite?.domain_uuid || null;
  const [formData, setFormData] = useState({
    name: "",
    destination: "",
    action: "",
    action_2: "",
    limit: "",
    caller_id_prefix: "",
    order_action: "",
    enabled: true,
    description: "",
  });

  const [conditions, setConditions] = useState([
    { type: "", value: "" }
  ]);
  const [extensionList, setExtensionList] = useState([]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [tonesList, setTonesList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [recordingsList, setRecordings] = useState([]);
  const [error, setError] = useState("");

  // Fetch extensions on component mount
  useEffect(() => {
    const fetchExtensions = async () => {
      try {
        const res = await fetch(`${serverHost}/get_rows?table=v_extensions&pageSize=50&page=&domain_uuid=${encodeURIComponent(domain_uuid)}`);
        if (res.ok) {
          const data = await res.json();
          const extensions = (data.results).map(r => ({
            extension_uuid: r.extension_uuid,
            extension: r.extension,
            value: `transfer:${r.extension} XML ${r.accountcode}`
          }));
          console.log(extensions)
          setExtensionList(extensions);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchVoicemails = async () => {
      try {
        const res = await fetch(`${serverHost}/get_rows?table=v_voicemails&pageSize=50&page=1&domain_uuid=${encodeURIComponent(domain_uuid)}`);
        if (res.ok) {
          const data = await res.json();
          console.log(data)
          const voicemails = (data.results).map(r => ({
            voicemail_uuid: r.voicemail_uuid,
            voicemail_id: r.voicemail_id,
            value: `transfer:*99${r.voicemail_id} XML ${r.accountcode}`
          }));
          console.log(voicemails)
          setVoicemailList(voicemails);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchIVRMenus = async () => {
      try {
        const res = await fetch(`${serverHost}/get_rows?table=v_ivr_menus&pageSize=500&page=1&domain_uuid=${encodeURIComponent(domain_uuid)}`);
        if (res.ok) {
          const data = await res.json();
          console.log(data)
          const ivrs = (data.results).map(v => ({
            value: v.ivr_menu_uuid,
            transfer: `${v.ivr_menu_extension} XML ${v.ivr_menu_context}`,
            name: v.ivr_menu_name,
          }));
          console.log(ivrs)
          setIVRList(ivrs);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchTones = async () => {
      try {
        const res = await fetch(`${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Tones&domain_uuid=${encodeURIComponent(domain_uuid)}`);
        if (res.ok) {
          const data = await res.json();
          console.log(data)
          const tones = (data.results).map(r => ({
            value: `playback:tone_stream://${r.var_value}`,
            name: r.var_name
          }));
          console.log(tones)
          setTonesList(tones);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };

    const fetchRecordings = async () => {
      try {
        const res = await fetch(`${serverHost}/get_rows?table=v_recordings&pageSize=500&page=1&domain_uuid=${encodeURIComponent(domain_uuid)}`);
        if (res.ok) {
          const data = await res.json();
          console.log(data)
          const recordings = (data.results).map(r => ({
            value: r.recording_uuid,
            transfer: `lua:streamfile.lua ${r.recording_filename}`,
            name: r.recording_name,
          }));
          console.log(recordings)
          setRecordings(recordings);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    fetchExtensions();
    fetchVoicemails();
    fetchIVRMenus();
    fetchRecordings();
    fetchTones();
  }, []);

  const handleChange = (eOrName, value) => {
    // If called with an event
    if (eOrName?.target) {
      const { name, type, checked, value } = eOrName.target;
      setFormData(prev => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    }
    // If called manually: handleChange("field", value)
    else {
      setFormData(prev => ({
        ...prev,
        [eOrName]: value
      }));
    }
  };

  const addCondition = () => {
    if (conditions.length < 2) {
      setConditions([...conditions, { type: "", value: "" }]);
    }
  };

  const removeCondition = (index) => {
    if (conditions.length > 1) {
      setConditions(conditions.filter((_, i) => i !== index));
    }
  };

  const updateCondition = (index, field, value) => {
    const updated = [...conditions];
    updated[index][field] = value;
    setConditions(updated);
  };

  const handleSave = async () => {
    // Validate required fields
    const missingRequired = [];
    if (!formData.name) missingRequired.push("Name");
    if (!formData.destination && !advanced) missingRequired.push("Destination");
    if (!formData.action) missingRequired.push("Action");
    if (!formData.order_action) missingRequired.push("Order Action");
    if (missingRequired.length) {
      setError(`Missing required fields: ${missingRequired.join(", ")}`);
      return;
    }

    // Validate conditions

    const invalidConditions = conditions.filter(c => !c.type || !c.value);
    if (invalidConditions.length > 0 && advanced) {
      setError("All conditions must have both type and value specified");
      return;
    }

    setError("");

    try {
      const site = JSON.parse(localStorage.getItem("selectedSite"));

      const payload = {
        data: {
          ...formData,
          advanced: advanced,
          conditions: conditions,
          dialplan_context: "public",
          dialplan_type: "inbound"
        },
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid
      };

      const res = await fetch(`${serverHost}/insert_inbound/${site.domain_uuid}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let fail = "";
        if (res.status === 403) fail = "; Limit reached";
        throw new Error("Failed to insert record" + fail);
      }

      navigate("/admin/hucs/inbound-routes");
    } catch (err) {
      console.log(err);
      setError(err.message);
    }
  };

  const labelStyle = {
    fontWeight: "bolder",
    color: isDark ? "#e2e8f0" : "#1e3a5f",
    marginBottom: '0.5rem'
  };

  const handleBack = () => {
    if (
      Object.values(formData).some((val) => val !== "" && val !== null) &&
      !window.confirm("Discard changes and go back?")
    )
      return;
    navigate("/admin/hucs/inbound-routes");
  };

  return (
    <>
      <SimpleHeader name="Add Inbound Route" parentName="HUCS" />
      <Container className="mt--6">
        <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
          <Card.Header style={{
            backgroundColor: isDark ? "#1f2937" : "#e9ecef",
            color: isDark ? "#e2e8f0" : "#1e3a5f",
            borderBottom: 'none',
            padding: '1rem 1.5rem'
          }}>
            <h4 className="mb-0">ADD INBOUND ROUTE</h4>
          </Card.Header>
          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}

            <Form className="edit-form">
              {/* Info Section */}
              <div className="mb-4">
                <Row className="d-flex justify-content-between align-items-center">
                  <h5 className="section-title mb-3" style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    Info
                  </h5>
                  <Button
                    size="sm"
                    className="d-flex align-items-center gap-1"
                    onClick={() => setAdvanced(prev => !prev)}
                  >
                    {advanced ? "Basic" : "Advanced"}
                  </Button>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        Name <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{ color: "#000" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    {!advanced && (
                      <Form.Group className="mb-3">
                        <Form.Label style={labelStyle}>
                          Destination <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          name="destination"
                          type="text"
                          value={formData.destination}
                          onChange={handleChange}
                          style={{ color: "#000" }}
                          placeholder="e.g., 1000, ^(\d{10})$"
                        />
                      </Form.Group>
                    )}
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        Action <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Input
                        type="select"
                        name="action"
                        value={formData.action}
                        onChange={handleChange}
                      >
                        <option value="">Select...</option>
                        {extensionList.length > 0 && <optgroup label="Extensions">
                          {extensionList.map((ext) => (
                            <option key={ext.extension_uuid} value={ext.value}>
                              {ext.extension}
                            </option>
                          ))}
                        </optgroup>}
                        {ivrList.length > 0 && <optgroup label="IVRs">
                          {ivrList.map((ivr) => (
                            <option key={ivr.value} value={`transfer:${ivr.transfer}`}>
                              {ivr.name}
                            </option>
                          ))}
                        </optgroup>}
                        <optgroup label="Tones">
                          {tonesList.map((opt) => (
                            <option key={opt.name} value={opt.value}>{opt.name}</option>
                          ))}
                        </optgroup>
                        {recordingsList.length > 0 && <optgroup label="Recordings">
                          {recordingsList.map((r) => (
                            <option key={r.value} value={r.transfer}>
                              {r.name}
                            </option>
                          ))}
                          </optgroup>}
                        {voicemailList.length > 0 && <optgroup label="Voicemails">
                          {voicemailList.map((vc) => (
                            <option key={vc.voicemail_uuid} value={vc.value}>
                              {vc.voicemail_id}
                            </option>
                          ))}
                        </optgroup>}
                        <optgroup label="Dialplans">
                          {dialplans.map((dp) => (
                            <option key={dp.value} value={dp.value}>
                              {dp.label}
                            </option>
                          ))}
                        </optgroup>
                      </Input>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Limit</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.limit}
                        onChange={(e) => handleChange("limit", e.target.value)}
                        style={{ color: "#000" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Caller ID Prefix</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.caller_id_prefix}
                        onChange={(e) => handleChange("caller_id_prefix", e.target.value)}
                        style={{ color: "#000" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>Order Action <span style={{ color: "red" }}>*</span> </Form.Label>
                      <Form.Control
                        type="number"
                        value={formData.order_action}
                        onChange={(e) => handleChange("order_action", e.target.value)}
                        style={{ color: "#000" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.5rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        <span style={{ color: isDark ? "#e2e8f0" : "#495057" }}>
                          Enabled
                        </span>
                        <label className="custom-toggle mb-0">
                          <input
                            type="checkbox"
                            id="enabled"
                            name="enabled"
                            checked={formData.enabled}
                            onChange={handleChange}
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            data-label-off="Off"
                            data-label-on="On"
                          />
                        </label>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        value={formData.description}
                        onChange={(e) => handleChange("description", e.target.value)}
                        style={{ color: "#000" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Conditions Section */}
              {advanced && (
                <div className="mb-4">

                  {/* Conditions Section */}
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5
                        className="section-title mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "700" }}
                      >
                        Conditions
                      </h5>
                      <Button
                        variant="success"
                        onClick={addCondition}
                        size="sm"
                        className="d-flex align-items-center gap-1"
                      >
                        + Add Condition
                      </Button>
                    </div>

                    {conditions.map((condition, index) => (
                      <Card key={index} className="mb-3" style={{ backgroundColor: "#f8f9fa" }}>
                        <Card.Body>
                          <Row className="align-items-center">
                            <Col md={5}>
                              <Form.Group className="mb-2">
                                <Form.Label>Condition Type</Form.Label>
                                <Form.Select
                                  value={condition.type}
                                  onChange={(e) => updateCondition(index, "type", e.target.value)}
                                >
                                  <option value="">Select type...</option>
                                  {conditionTypeOptions.map((opt) => (
                                    <option key={opt} value={opt}>
                                      {opt.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Group className="mb-2">
                                <Form.Label>Value / Expression</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={condition.value}
                                  onChange={(e) => updateCondition(index, "value", e.target.value)}
                                  style={{ color: "#000" }}
                                  placeholder="e.g., ^(\\d{10})$ or specific value"
                                />
                              </Form.Group>
                            </Col>

                            <Col md={1} className="d-flex align-items-end">
                              {conditions.length > 1 && (
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => removeCondition(index)}
                                  className="mb-2"
                                >
                                  ✕
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>

                  {/* Advanced Settings Section */}
                  <div className="mb-4">
                    <h5
                      className="section-title mb-3"
                      style={{ fontSize: "1.5rem", fontWeight: "700" }}
                    >
                      Advanced Settings
                    </h5>

                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Secondary Action</Form.Label>
                          <Form.Select
                            value={formData.action_2}
                            onChange={(e) => handleChange("action_2", e.target.value)}
                          >
                            <option value="">Select...</option>

                            {extensionList.length > 0 && (
                              <optgroup label="Extensions">
                                {extensionList.map((ext) => (
                                  <option key={ext.extension_uuid} value={ext.value}>
                                    {ext.extension}
                                  </option>
                                ))}
                              </optgroup>
                            )}

                            <optgroup label="Tones">
                              {tonesList.map((opt) => (
                                <option key={opt.name} value={opt.value}>{opt.name}</option>
                              ))}
                            </optgroup>

                            {voicemailList.length > 0 && (
                              <optgroup label="Voicemails">
                                {voicemailList.map((vc) => (
                                  <option key={vc.voicemail_uuid} value={vc.value}>
                                    {vc.voicemail_id}
                                  </option>
                                ))}
                              </optgroup>
                            )}

                            <optgroup label="Dialplans">
                              {dialplans.map((dp) => (
                                <option key={dp.value} value={dp.value}>
                                  {dp.label}
                                </option>
                              ))}
                            </optgroup>

                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                </div>
              )}

              {/* Action Buttons */}
              <div className="mt-4 d-flex justify-content-between">
                <Button
                  variant="danger"
                  onClick={handleBack}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={handleSave}
                  disabled={!formData.name || (!formData.destination && !advanced) || (!conditions.some(c => c.type || c.value) && advanced) || !formData.action}
                >
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default DialplanInboundAdd;